import { render, staticRenderFns } from "./AltaImpago.vue?vue&type=template&id=2e7af07c&scoped=true&"
import script from "./AltaImpago.vue?vue&type=script&lang=js&"
export * from "./AltaImpago.vue?vue&type=script&lang=js&"
import style0 from "./AltaImpago.vue?vue&type=style&index=0&id=2e7af07c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7af07c",
  null
  
)

export default component.exports